<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> help_outline </span>
      <p>Ajuda</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()"> close </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      Quem se enquadra como pessoa exposta politicamente (PEP)?
    </h1>
    <p class="TxtModal text-start">
      Pessoas Expostas Politicamente (PEP) são aquelas que exercem ou
      exerceram nos últimos 5 anos algum cargo ou posição de destaque
      político, listados na Resolução COAF nº 29, de 2017. Ex: prefeitos,
      vereadores, membros do Conselho Nacional de Justiça.
    </p>
  </div>
</div>
